import { TokenTypes } from 'types';

export const determineTokenFeeInUsdDecimals = (token?: TokenTypes) => {
  if (token === 'usdt' || token === 'usdc') return 6;
};
